const actions = {
    GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA: "GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA",
    GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS: "GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS",
    GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED: "GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED",
    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA",
    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS",
    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED",
    RESET_DAILY_ADDON_PRICE_MAPPING_MESSAGES: "RESET_DAILY_ADDON_PRICE_MAPPING_MESSAGES",

    OPEN_UPDATE_DAILY_ADDON_MODAL: "OPEN_UPDATE_DAILY_ADDON_MODAL",
    CLOSE_UPDATE_DAILY_ADDON_MODAL: "CLOSE_UPDATE_DAILY_ADDON_MODAL",

    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID",
    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_SUCCESS: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_SUCCESS",
    UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_FAILED: "UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_FAILED",

    openUpdateDailyAddonModal: () => ({
        type: actions.OPEN_UPDATE_DAILY_ADDON_MODAL,
    }),

    closeUpdateDailyAddonModal: () => ({
        type: actions.CLOSE_UPDATE_DAILY_ADDON_MODAL,
    }),

    updateDailyAddonMappingDataByDealerId: (dealerId, data) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID,
        payload: { dealerId, data }
    }),
    updateDailyAddonMappingDataByDealerIdSuccess: (message) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_SUCCESS,
        payload: { message }
    }),
    updateDailyAddonMappingDataByDealerIdFailed: (error) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_FAILED,
        payload: { error }
    }),


    getAllDailyAddonPriceMappingData: () => ({
        type: actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA,
    }),
    getAllDailyAddonPriceMappingDataSuccess: (data) => ({
        type: actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS,
        payload: { data }
    }),
    getAllDailyAddonPriceMappingDataFailed: (error) => ({
        type: actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED,
        payload: { error }
    }),
    updateDailyAddonPriceMappingData: (data) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA,
        data
    }),
    updateDailyAddonPriceMappingDataSuccess: (message, data) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS,
        message, data
    }),
    updateDailyAddonPriceMappingDataFailed: (error) => ({
        type: actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED,
        error
    }),
    resetDailyAddonPriceMappingMessages: () => ({
        type: actions.RESET_DAILY_ADDON_PRICE_MAPPING_MESSAGES,
    })

}
export default actions;